

export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center pt-20"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/075b4cfd7d1337ccb362488c07a9e41f.jpeg)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 w-full">
        <div className="flex flex-col lg:flex-row items-center justify-between">
          <div className="w-full lg:w-1/2 text-white text-center lg:text-left">
            <div className="mb-4 md:mb-6 flex items-center justify-center lg:justify-start space-x-3">
              <div className="flex -space-x-2">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-blue-600 border-2 border-white flex items-center justify-center">
                  <i className="ri-user-fill text-white text-sm md:text-lg"></i>
                </div>
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-blue-700 border-2 border-white flex items-center justify-center">
                  <i className="ri-user-fill text-white text-sm md:text-lg"></i>
                </div>
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-blue-800 border-2 border-white flex items-center justify-center">
                  <i className="ri-user-fill text-white text-sm md:text-lg"></i>
                </div>
              </div>
              <span className="text-sm md:text-lg font-semibold">500+ Happy Homeowners</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold mb-4 md:mb-6 leading-tight">
              <span className="block">TRANSFORMING HOUSES</span>
              <span className="block">INTO DREAM HOMES</span>
            </h1>

            <p className="text-base sm:text-lg md:text-xl mb-6 md:mb-8 text-white/95 max-w-xl mx-auto lg:mx-0 leading-relaxed px-2 sm:px-0">
              Professional remodeling services with 40 years of expertise. Committed to quality craftsmanship that exceeds expectations.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 sm:gap-4">
              <button
                onClick={scrollToContact}
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold transition-all duration-300 flex items-center space-x-2 cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl w-full sm:w-auto justify-center"
              >
                <span>Get in touch!</span>
                <i className="ri-arrow-right-line text-lg sm:text-xl"></i>
              </button>

            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl sm:text-3xl"></i>
      </div>
    </section>
  );
}
